import DashboardLayout from "../Layouts/DashboardLayout";

const waste = [
  {
    item: "Milk",
    quantity: 5,
    unit: "Litres",
    reason: "Spoilage",
    date: "2026-01-05",
  },
  {
    item: "Kaju Katli",
    quantity: 3,
    unit: "Kg",
    reason: "Damaged Packaging",
    date: "2026-01-04",
  },
];

export default function WasteTracking() {
  return (
    <DashboardLayout>
      <div className="space-y-8">

        <div className="flex items-center justify-between">
          <h1 className="text-2xl font-serif text-red-400">
            Waste Tracking
          </h1>
          <button className="px-5 py-2 rounded-xl bg-red-500 text-white font-medium">
            + Log Waste
          </button>
        </div>

        <div className="rounded-2xl bg-white/5 border border-white/10 overflow-hidden">
          <table className="w-full text-sm">
            <thead className="bg-black/40 text-gray-400">
              <tr>
                <th className="px-6 py-4 text-left">Item</th>
                <th className="px-6 py-4">Quantity</th>
                <th className="px-6 py-4">Reason</th>
                <th className="px-6 py-4">Date</th>
              </tr>
            </thead>
            <tbody>
              {waste.map((w, i) => (
                <tr key={i} className="border-t border-white/10 hover:bg-white/5">
                  <td className="px-6 py-4">{w.item}</td>
                  <td className="px-6 py-4 text-center">
                    {w.quantity} {w.unit}
                  </td>
                  <td className="px-6 py-4 text-center">{w.reason}</td>
                  <td className="px-6 py-4 text-center">{w.date}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

      </div>
    </DashboardLayout>
  );
}
